import React from 'react';
import './App.css';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { BrokerContainer } from './components/features/broker/BrokerContainer';
import { PricingContainer } from './components/features/pricing/PricingContainer';
import { ThemeProvider, createTheme } from '@mui/material';
import { DrawerContainer } from './components/shared/drawer/DrawerContainer';
import { MainWrapperContainer } from './components/features/main-wrapper/MainWrapperContainer';
import { ToasterContainer } from './components/shared/toaster/ToasterContainer';
import { HomePage } from './components/features/home/HomePage';

function App() {
  const theme = createTheme({
		typography: {
			fontFamily: 'Rubik, sans-serif',
		},
	})

  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <BrowserRouter basename="/pricetag">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/pricepublisher" element={<MainWrapperContainer />} />
            <Route path="/pricesubscriber" element={<MainWrapperContainer />} />
            <Route path="/pricetags" element={<MainWrapperContainer />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <ToasterContainer data={undefined} />
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
